module.exports = __webpack_public_path__ + "img/vi-box4-text-light.df202938.png";